import { render } from "./MenuButton.vue?vue&type=template&id=8eef5eca"
import script from "./MenuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuButton.vue?vue&type=script&setup=true&lang=js"

import "./MenuButton.vue?vue&type=style&index=0&id=8eef5eca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Wishlist/MenuButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8eef5eca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8eef5eca', __exports__)) {
    api.reload('8eef5eca', __exports__)
  }
  
  module.hot.accept("./MenuButton.vue?vue&type=template&id=8eef5eca", () => {
    api.rerender('8eef5eca', render)
  })

}


export default __exports__